import { css } from '@linaria/core';
import { baseTheme, breakpoints } from 'styles/utils';
export const dialogStyles = "omponents__Dialog__Dialog_styles_ts-dialogStyles-d74c84b";
export const backdropStyles = "omponents__Dialog__Dialog_styles_ts-backdropStyles-bdamhcm";

require("./Dialog_styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Dialog_styles.ts");